import { Validator } from 'vee-validate';

// /**
//  * Validation Config
//  */
Validator.extend('sNorms', {
    getMessage(field) {
        return `The ${field} field must be smaller`;
    },
    validate(value, args) {
        return !args.some(arg => parseFloat(value) <= arg);
    },
});

Validator.extend('bNorms', {
    getMessage(field) {
        return `The ${field} field must be bigger`;
    },
    validate(value, args) {
        return !args.some(arg => parseFloat(value) >= arg);
    },
});
// Greater equal
Validator.extend('gEqual', {
    validate(value, args) {
        return !args.some(arg => parseFloat(value) < arg);
    },
});
// Less equal
Validator.extend('lEqual', {
    validate(value, args) {
        return !args.some(arg => parseFloat(value) > arg);
    },
});

Validator.extend('requiredOption', {
    getMessage: field => this.$t('validationMsg.requiredOption', { field }),
    validate(value, args) {
        return {
            valid: args.length > 0,
            data: {
                required: true,
            },
        };
    },
}, {
    computesRequired: true,
});

Validator.extend('compareString', {
    validate(value, args) {
        return args.some(arg => arg.toLowerCase() !== value.toLowerCase());
    },
});

Validator.extend('cantBeZero', {
    getMessage() {
        return this.$t('validationMsg.cantBeZero');
    },
    validate(value) {
        return parseInt(value, 10) !== 0;
    },
});

Validator.extend('analysisCondition0To14', {
    validate(value) {
        return value >= 0 && value <= 14;
    },
});

export default {};
